import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../../../head-container';
import { getImageFromS3 } from '../../../../imageService';
import InputMask from 'react-input-mask';
import apiService from '../../../../utils/apiService';
import classNames from 'classnames';
import { executeRecaptchaV3 } from '../../../../utils/recaptchaV3';
import {
  getEventId,
  getVisitorId,
  isVisitorLimitError,
  VISITOR_LIMIT_STATUS
} from '../../../../utils/fingerprint';

const RECAPTCHA_V3_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;
const RECAPTCHA_ACTION = 'feedback_action';

const PhoneInputComponent = ({
  setScreenNumber,
  handleBackButtonClick,
  data,
  handleSuccessOtpSend,
  isDarkMode = false
}) => {
  const isQrCode = sessionStorage.getItem('isQrCode');
  const productMatch = isQrCode?.match(/\d{2}UA[^?& \s]*/);
  const projectPath = productMatch
    ? productMatch[0]
    : isQrCode?.includes('utm_campaign=')
      ? isQrCode.split('utm_campaign=')[1].split('&')[0]
      : isQrCode;
  const [isError, setIsError] = useState(false);
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckError, setIsCheckError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [data]);

  const handleSubmit = async () => {
    const regex = /^380\d{9}$/;
    const updatedPhone = phone.replace(/\D/g, '').replace(/^380/, '380');

    setPhoneError(!regex.test('380' + updatedPhone));
    setIsCheckError(!isChecked);

    sessionStorage.setItem('p_n', '380' + updatedPhone);

    if (regex.test('380' + updatedPhone) && data.files && isChecked) {
      const formData = new FormData();

      data.files.forEach((file) => {
        formData.append('files', file);
      });

      formData.append('phone', '380' + updatedPhone);
      formData.append('link', 'https://yourjourney.com.ua/' + projectPath);
      formData.append('sku_code', projectPath ? projectPath : isQrCode);
      formData.append('channel', 'YourJourney');
      formData.set('callback', data?.callback);
      Object.entries(data).forEach(([key, value]) => {
        if (key !== 'files' && key !== 'callback') {
          formData.append(key, value);
        }
      });

      try {
        setIsSubmitting(true);

        const visitorId = await getVisitorId();
        if (visitorId) {
          formData.append('visitor_id', visitorId);
        }

        const eventId = await getEventId();
        if (eventId) formData.append('event_id', eventId);

        const recaptchaToken = RECAPTCHA_V3_SITE_KEY
          ? await executeRecaptchaV3(RECAPTCHA_V3_SITE_KEY, RECAPTCHA_ACTION)
          : null;

        const headers = { 'Content-Type': 'multipart/form-data' };
        if (recaptchaToken) {
          headers['recaptcha-token'] = recaptchaToken;
          headers['recaptcha-action'] = RECAPTCHA_ACTION;
        }

        const {
          data: { id, status }
        } = await apiService.post('feedback', {
          data: formData,
          headers
        });
        localStorage.setItem('rw_id', id);
        handleSuccessOtpSend(status);
      } catch (e) {
        if (isVisitorLimitError(e)) {
          handleSuccessOtpSend(VISITOR_LIMIT_STATUS);
        } else {
          setIsError(true);
        }
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setIsError(true);
    }
  };
  const handleCheckPhone = () => {
    const regex = /^380\d{9}$/;
    const updatedPhone = phone.replace(/\D/g, '').replace(/^380/, '380');

    if (!regex.test('380' + updatedPhone)) setPhoneError(true);

    return regex.test('380' + updatedPhone);
  };

  return (
    <div
      className={classNames(
        styles.phoneNumberContainer,
        isDarkMode ? styles.darkPhoneNumberContainer : ''
      )}
      style={{
        backgroundImage: isDarkMode
          ? ''
          : `url("${getImageFromS3(
              'images/review-screen/violet-background.png'
            )}")`
      }}
    >
      <HeadContainer setScreenNumber={setScreenNumber} />
      <div className={styles.content}>
        <p className={styles.title}>Введи, будь ласка, свій номер телефону</p>
        <div className={styles.phoneInputContainer}>
          <div className={styles.labelContainer}>
            <p>Код</p>
            <p>Номер телефону*</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.codeContainer}>+380</div>
            <InputMask
              mask="(99) 999-99-99"
              maskChar="_"
              alwaysShowMask
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onFocus={() => setPhoneError(false)}
              onBlur={handleCheckPhone}
              className={classNames(
                styles.input,
                phoneError && styles.errorInput
              )}
            >
              {(inputProps) => <input {...inputProps} type="tel" />}
            </InputMask>
            {phoneError && (
              <i className={styles.phoneErrorIcon}>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_0_76)">
                    <circle cx="14" cy="10" r="10" fill="#F9524D" />
                    <path
                      d="M14.9444 5L14.7407 12.555H13.2593L13.0494 5H14.9444ZM13 14.894C13 14.5752 13.0905 14.3111 13.2716 14.1019C13.4568 13.8877 13.6996 13.7806 14 13.7806C14.3045 13.7806 14.5473 13.8877 14.7284 14.1019C14.9095 14.3111 15 14.5752 15 14.894C15 15.2029 14.9095 15.4644 14.7284 15.6787C14.5473 15.8929 14.3045 16 14 16C13.6996 16 13.4568 15.8929 13.2716 15.6787C13.0905 15.4644 13 15.2029 13 14.894Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_0_76"
                      x="0"
                      y="0"
                      width="28"
                      height="28"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_0_76"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_0_76"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </i>
            )}
          </div>
        </div>
        {phoneError && (
          <p className={styles.textError}>Невірний формат номеру</p>
        )}
        <p className={styles.subtitle}>
          Отримати поповнення за відгук про продукт можна{' '}
          <b>один раз на місяць</b>
        </p>
        <p className={styles.description}>
          *поповнення мобільного телефону можливе для усіх операторів України
          окрім контрактних номерів
        </p>
        <div className={styles.privacyPolicy}>
          <input
            type="checkbox"
            id="privacy"
            name="privacy"
            onClick={() => {
              setIsChecked(!isChecked);
              setIsCheckError(false);
            }}
            checked={isChecked}
          />
          <span
            className={classNames(
              styles.checkmark,
              isCheckError && styles.errorInput
            )}
          ></span>
          <label htmlFor="privacy">
            Я погоджуюсь з{' '}
            <a
              href="https://yourjourney.com.ua/personal-data-policy"
              target="_blank"
            >
              положенням про конфіденційність та захист персональних даних
            </a>{' '}
            та підтверджую, що є споживачем тютюнових виробів та/або
            користувачем пристроїв для споживання тютюнових виробів без їх
            згоряння
          </label>
        </div>
        <button
          className={classNames(
            styles.menuButton,
            isDarkMode && styles.goldButton
          )}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isDarkMode && (
            <img src="/images/gold-button.png" alt="gold-button" />
          )}
          {isSubmitting && <span className={styles.spinner} />}
          <span>Надіслати</span>
        </button>
        <button
          className={classNames(
            styles.backButton,
            isDarkMode && styles.darkBackButton
          )}
          onClick={handleBackButtonClick}
        >
          Назад
        </button>
        {/*{RECAPTCHA_V3_SITE_KEY && (*/}
        {/*  <p*/}
        {/*    style={{*/}
        {/*      marginTop: 12,*/}
        {/*      fontSize: 11,*/}
        {/*      lineHeight: 1.35,*/}
        {/*      textAlign: 'center',*/}
        {/*      opacity: 0.7*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    Цей сайт захищено reCAPTCHA — діють{' '}*/}
        {/*    <a*/}
        {/*      href="https://policies.google.com/privacy"*/}
        {/*      target="_blank"*/}
        {/*      rel="noreferrer"*/}
        {/*      style={{ color: 'inherit', textDecoration: 'underline' }}*/}
        {/*    >*/}
        {/*      Політика конфіденційності*/}
        {/*    </a>{' '}*/}
        {/*    та{' '}*/}
        {/*    <a*/}
        {/*      href="https://policies.google.com/terms"*/}
        {/*      target="_blank"*/}
        {/*      rel="noreferrer"*/}
        {/*      style={{ color: 'inherit', textDecoration: 'underline' }}*/}
        {/*    >*/}
        {/*      Умови використання*/}
        {/*    </a>{' '}*/}
        {/*    Google.*/}
        {/*  </p>*/}
        {/*)}*/}
      </div>
    </div>
  );
};

export default PhoneInputComponent;
